import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    teachersList: [],
    teacherDetails: null,
    loading: false,
    error: null,
    response: null,
};

const teacherSlice = createSlice({
    name: 'teacher',
    initialState,
    reducers: {
        getRequest: (state) => {
            state.loading = true;
        },
        doneSuccess: (state, action) => {
            state.teacherDetails = action.payload;
            state.loading = false;
            state.error = null;
            state.response = null;
        },
        getSuccess: (state, action) => {
            state.teachersList = action.payload;
            state.loading = false;
            state.error = null;
            state.response = null;
        },
        getFailed: (state, action) => {
            state.response = action.payload;
            state.loading = false;
            state.error = null;
        },
        /** Avoid showing a previous teacher when GET /Teacher/:id returns an error message. */
        teacherDetailLoadFailed: (state, action) => {
            state.teacherDetails = null;
            state.response = action.payload;
            state.loading = false;
            state.error = null;
        },
        getError: (state, action) => {
            state.loading = false;
            state.error = action.payload;
        },
        postDone: (state) => {
            state.loading = false;
            state.error = null;
            state.response = null;
        },
        clearTeacherFeedback: (state) => {
            state.response = null;
            state.error = null;
        },
    },
});

export const {
    getRequest,
    getSuccess,
    getFailed,
    teacherDetailLoadFailed,
    getError,
    doneSuccess,
    postDone,
    clearTeacherFeedback,
} = teacherSlice.actions;

export const teacherReducer = teacherSlice.reducer;